<template>
  <div id="app">
   
    <TheTopMenu></TheTopMenu>
    
    <router-view></router-view>
    <footer style="text-align: center;padding: 75px 0px 50px 0px;">
    <div class="ui divider"></div>
    <br>
    This site was created as part of the project supported by The Czech Science Foundation (GA ČR) no. 20-15927S Art for Display: The painting collection of Emperor Rudolf II within the context of collecting practices circa 1600.
    </footer>
  </div>
</template>

<script>
  import TheTopMenu from './components/TheTopMenu.vue'

  export default {
    name: 'App',
    components: {
      TheTopMenu,
    },

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue